import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-shares-template-info',
  imports: [TranslatePipe],
  templateUrl: './shares-template-info.component.html',
  styleUrls: [
    './shares-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class SharesTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'share.';
}
